<template>
  <modal @closeModal="closeModal">
    <div slot="header">
      <h3><i class="fas fa-exclamation-circle"></i> {{title}}</h3>
    </div>
    <div slot="body">
      <div v-html="text"></div>
    </div>
    <div slot="footer">
      <button class="btn btn-default" @click="closeModal">{{$t('modal.close')}}</button>
    </div>
  </modal>
</template>

<script>
  import i18n from '../../i18n';
  import Modal from '../modal';

  export default {
    props: {
      title: {
        type: String,
        default: () => i18n.t('errors.default_title')
      },
      text: {
        type: String,
        default: () => i18n.t('errors.default_text')
      }
    },

    components: {
      'modal': Modal
    },

    methods: {
      closeModal () {
        this.$emit('closeModal');
      }
    }
  }
</script>